import styled from "styled-components";
import { ButtonBaseStyle } from "./baseStyle";
import { Link } from "react-router-dom";
import { BaseText, TextBlock } from "../text";
import { THEME_COLORS } from "../../styles/theme";
import { FontFamilyRegular } from "../fonts";
import { size } from "../media-queries";
import { InputGradient } from ".";
import { MarginTop16 } from "../margins";

export const ButtonStyle = styled.button`
    ${ButtonBaseStyle};
`;

export const LinkStyle = styled(Link)`
    ${ButtonBaseStyle}
    display: block;
`;

export const LinkOutsideSite = styled.a`
    ${ButtonBaseStyle}
    display: block;
`;

export const InputSubmitStyle = styled.input`
    ${ButtonBaseStyle};
    display: block;
`;

export const LabelButtonStyle = styled.span`
    ${BaseText}
    ${FontFamilyRegular};
    color: ${props => props.theme.color[props.color] || props.theme.color[THEME_COLORS.white]};
`;

export const ButtonIconWrapper = styled.div`
    width: 25px;
    height: 25px;
    margin-right: 10px;
`;

export const SubmitButtonContainerStyle = styled.div`
    width: 100%;
    margin-top: 40px;
    ${props => props.theme.mediaQueries.tablet} {
        width: 50%;
    }
`;

export const SubmitButtonStyle = styled(InputSubmitStyle)`
    color: white;
    font-size: 20px;
    height: 60px;
    width: 100%;
    transition: opacity 0.2 ease-in-out;
    opacity: ${props => props.disabled ? 0.5 : 1};
`;

export const SubmitButtonErrorText = styled(TextBlock)`
    color: ${props => props.theme.color.red};
    ${MarginTop16};
    padding-left: 24px;
`;

export const SubmitButtonSuccessText = styled(TextBlock)`
    color: ${props => props.theme.color.green};
    ${MarginTop16};
    padding-left: 24px;
`;